import { Link } from "react-router-dom";
import { Heart, MessageCircle, UserPlus } from "lucide-react";
import { timeAgo } from "@/lib/dates";

const KIND_ICON = { comment: MessageCircle, heart: Heart, member_joined: UserPlus };

function activityText(a) {
    if (a.kind === "member_joined") return `${a.actor_name} joined the family`;
    return `${a.actor_name} ${a.kind === "heart" ? "loved" : "commented on"} “${a.memory_label || "a memory"}”`;
}

export function ActivityFeed({ items }) {
    if (!items.length) return null;
    return (
        <section data-testid="activity-feed" className="mt-8">
            <h2 className="font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-[#C98A94]">Family activity</h2>
            <div className="mt-3 flex gap-3 overflow-x-auto pb-2">
                {items.map((a, i) => {
                    const Icon = KIND_ICON[a.kind] || MessageCircle;
                    const inner = (
                        <div className="flex min-w-[240px] items-center gap-3 rounded-2xl border-2 border-warmgray bg-ivory px-4 py-3">
                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-lavender to-peach">
                                <Icon size={14} className="text-white" />
                            </span>
                            <div className="min-w-0">
                                <p className="truncate text-xs font-medium text-navy">{activityText(a)}</p>
                                <p className="mt-0.5 font-mono text-[9px] uppercase tracking-widest text-navy/50">{timeAgo(a.created_at)}</p>
                            </div>
                        </div>
                    );
                    return a.memory_id ? (
                        <Link key={i} to={`/memories/${a.memory_id}`} data-testid={`activity-item-${i}`} className="shrink-0 transition-transform duration-300 hover:-translate-y-0.5">
                            {inner}
                        </Link>
                    ) : (
                        <div key={i} data-testid={`activity-item-${i}`} className="shrink-0">
                            {inner}
                        </div>
                    );
                })}
                <Link
                    to="/activity"
                    data-testid="activity-view-all"
                    className="flex min-w-[120px] shrink-0 items-center justify-center rounded-2xl border-2 border-dashed border-warmgray px-4 py-3 text-xs font-semibold text-navy/70 transition-colors duration-300 hover:border-peach hover:text-navy"
                >
                    View all
                </Link>
            </div>
        </section>
    );
}
